import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { map, Subject, takeUntil } from 'rxjs';
import { ThemeType } from 'src/app/shared/models';
import { CurrentFacilityService, ThemeService } from 'src/app/shared/services';

@Component({
    standalone: true,
    selector: 'app-header-logo',
    templateUrl: './header-logo.component.html',
    styleUrls: ['./header-logo.component.scss'],
    imports: [RouterModule, MatButtonModule],
})
export class HeaderLogoComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public defaultLogo: string;

    @Input() height: string;
    @Input() width: string;
    @Input() redirectURL: string;
    @Input() mode?: ThemeType;

    constructor(
        private themeService: ThemeService,
        private currentFacilityService: CurrentFacilityService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        if (!this.mode) {
            this.subscribeTheme();
        } else {
            this.defaultLogo = this.getLogoByMode(this.mode);
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getLogoByMode(mode: ThemeType): string {
        if (this.currentFacilityService.getAlternativeLogoToHeader()) {
            return this.currentFacilityService.getAlternativeLogoByMode(mode);
        }
        return this.currentFacilityService.getMainLogoByMode(mode);
    }

    subscribeTheme(): void {
        this.themeService
            .getTheme()
            .pipe(
                map((theme: ThemeType) => this.getLogoByMode(theme)),
                takeUntil(this.unsubscribe$)
            )
            .subscribe((logo) => (this.defaultLogo = logo));
    }

    getBackgroundImageUrl(): string {
        if (!this.defaultLogo) return '';
        const escapedUrl = this.defaultLogo.replace(/'/g, "\\'");
        return `url('${escapedUrl}')`;
    }
}
